<template>
  <div class="fixed z-[9999] inset-0 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen pt-4 px-6 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="closeModal">
        <div class="absolute inset-0 bg-gray-900/40 backdrop-blur-sm"></div>
      </div>

      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:w-full lg:w-3/4 max-w-4xl border border-gray-100" :class="{ 'sm:p-0': hasHeader }">
        <div v-if="hasHeader" class="px-8 pt-8 pb-4">
          <div class="flex items-center justify-between border-b border-gray-50 pb-4">
            <h3 class="text-4xl font-bold text-[#0d47a1]" id="modal-title">
              {{ title }}
            </h3>
            <button @click="closeModal" class="text-gray-400 hover:text-gray-600 transition-colors">
              <i class="material-icons">close</i>
            </button>
          </div>
        </div>
        
        <div class="px-8 py-2">
          <slot></slot>
        </div>

        <div class="px-8 py-6 bg-gray-50/50 flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-3 space-y-reverse space-y-3 sm:space-y-0">
          <button 
            type="button" 
            class="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-6 py-2.5 bg-white text-lg font-bold text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 transition-all" 
            @click="closeModal"
          >
            {{ cancelButtonText }}
          </button>
          <button 
            type="button" 
            class="inline-flex justify-center rounded-md border border-transparent shadow-md px-8 py-2.5 bg-[#0d47a1] text-lg font-bold text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" 
            @click="submitModal"
          >
            {{ submitButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel'
    },
    submitButtonText: {
      type: String,
      default: 'Submit'
    },
    hasHeader: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    submitModal() {
      this.$emit('submit-modal');
    }
  }
}
</script>
